<template>
  <default-layout>
    <ContactsCard
      :agents="agents"
      :broker-company="brokerCompany"
      :contacts-modules="contactsModules"
      :favourite-units-list="favourites"
      :project-settings="settings"
      class="contacts_card"
    />
  </default-layout>
</template>

<script>
/* ============
 * Account Index Page
 * ============
 *
 * Page where the user can view the account information.
 */
import { mapGetters } from 'vuex';
import DefaultLayout from '@/layouts/Default.vue';
import ContactsCard from '@/components/ContactsCard.vue';

export default {
  /**
   * The name of the page.
   */
  name: 'OrderProjectContacts',

  /**
   * The components that the page can use.
   */
  components: {
    DefaultLayout,
    ContactsCard,
  },
  computed: {
    ...mapGetters('project', [
      'styleDefault',
      'styles',
      'agents',
      'brokerCompany',
      'contactsModules',
      'settings',
    ]),
    ...mapGetters('units', ['favourites']),
  },
  data() {
    return {
      contactsCard: {
        contactPersons: [
          {
            avatar: 'https://avatars0.githubusercontent.com/u/9064066?v=4&s=460',
            name: 'Sara Svensson',
            department: 'The Realtors Sundsvall',
            contacts: [
              {
                type: 'phone',
                value: '123 456 789',
              },
              {
                type: 'email',
                value: 'sara.svensson@therealtors.se',
              },
              {
                type: 'info',
                value: 'some info',
              },
            ],
          },
          {
            avatar: 'https://avatars0.githubusercontent.com/u/9064066?v=4&s=460',
            name: 'Sara Svensson',
            department: 'The Realtors Sundsvall',
            contacts: [
              {
                type: 'phone',
                value: '123 456 789',
              },
              {
                type: 'email',
                value: 'sara.svensson@therealtors.se',
              },
              {
                type: 'info',
                value: 'some info',
              },
            ],
          },
        ],
        placeName: 'Brokerbrand',
        placeAddress: 'Street One',
        workHours: '8 AM - 5 PM',
        placePhone: '123 456 789',
        placeEmail: 'info@therealtors.se',
        form: {
          valid: true,
          name: null,
          nameRules: [
            v => !!v || 'Name is required',
          ],
          phone: null,
          email: null,
          emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid',
          ],
          message: null,
          messageRules: [
            v => !!v || 'Message is required',
          ],
          attachCheckbox: false,
          attachCheckboxLabel: 'Attach 3 saved units',
        },
      },
    };
  },
};
</script>
